<app-order-resume></app-order-resume>

<form *ngIf="formGroup" [formGroup]="formGroup">
  <div *ngIf="isSale()">
    <fd-select (loadItemsFn)="getMobileOperators()" [parentForm]="formGroup" [field]="fields.mobileOperator"> </fd-select>
  </div>
  <fd-button fdSecondary [content]="'cancelar'" id="btnCancel" (trigger)="back()"> </fd-button>
  <fd-button [content]="'próxima etapa'" id="btnNext" (trigger)="next()"> </fd-button>
</form>
